<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteStudentDialog"
    :title="$t('students.delete.confirm')"
    :confirm-text="$t('students.delete.delete')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>{{ $t('students.delete.message') }} <strong>{{ studentName }}</strong>؟</p>
      <p class="text-danger">{{ $t('students.delete.warning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const emit = defineEmits(['delete']);

const baseDialog = ref(null);
const loading = ref(false);
const studentName = ref('');
const studentId = ref(null);

const openDialog = (id, name) => {
  studentId.value = id;
  studentName.value = name;
  baseDialog.value.openDialog();
};

const closeDialog = () => {
  baseDialog.value.closeDialog();
};

const handleConfirm = async () => {
  loading.value = true;
  try {
    await emit('delete', studentId.value);
    closeDialog();
  } catch (error) {
    // Error handling is done in the parent
  } finally {
    loading.value = false;
  }
};

defineExpose({ openDialog, closeDialog });
</script>